import { render, staticRenderFns } from "./otpCodeInput.vue?vue&type=template&id=b2e274fc&"
import script from "./otpCodeInput.vue?vue&type=script&lang=js&"
export * from "./otpCodeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports